var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Keycloak from 'keycloak-js';
import { StreamEntity } from 'src/shared/StreamEntity';
import { saveInLocalStorage } from 'src/shared/helpers/storageHelpers';
import { broadcastToAllTabs, E_BROADCAST_MESSAGE } from 'src/shared/helpers/browserHelpers';
var KeycloakEntity = /** @class */ (function () {
    function KeycloakEntity() {
    }
    KeycloakEntity.init = function (keycloakConfig) {
        var _this = this;
        this.kcConfig = keycloakConfig;
        this.kc = new Keycloak(__assign({}, this.kcConfig));
        if (this.kc) {
            return this.kc
                .init({ onLoad: 'check-sso' })
                .then(function (authenticated) {
                _this.idToken = _this.kc.idToken;
                _this.kc
                    .loadUserInfo()
                    .then(function (res) { return (_this.userInfo = res); })
                    .catch(function (err) { return console.log('An error occurred when trying fetch keycloak userInfo', err); });
                return Promise.resolve(authenticated);
            })
                .catch(function (err) {
                if (!_this.kc.idToken && _this.idToken !== null) {
                    _this.kc.idToken = _this.idToken;
                }
                // Not conventional but asked to let the disconnection sound notification play
                setTimeout(function () { return _this.logout(); }, 500);
                console.log('An error occurred during Keycloak init:', err);
            });
        }
        else {
            throw new Error('Please init Keycloak first');
        }
    };
    KeycloakEntity.refreshToken = function () {
        var _this = this;
        var SECONDS_BEFORE_END_OF_VALIDITY = 45;
        var ACCESS_TOKEN_LIFESPAN_WARNING_THRESHOLD_MS = 290000; // 4mn 50s
        if (this.kc) {
            return this.kc
                .updateToken(SECONDS_BEFORE_END_OF_VALIDITY)
                .then(function (refreshed) {
                if (refreshed) {
                    var expirationTimeMs = _this.kc.tokenParsed.exp * 1000;
                    var expirationDurationMs = expirationTimeMs - new Date().getTime();
                    _this.idToken = _this.kc.idToken;
                    if (expirationDurationMs < ACCESS_TOKEN_LIFESPAN_WARNING_THRESHOLD_MS) {
                        var expirationDuration = (expirationDurationMs / 1000).toFixed(1);
                        var delayBetweenRefresh = (expirationDurationMs / 1000 - SECONDS_BEFORE_END_OF_VALIDITY * 1000).toFixed(1);
                        console.warn("".concat('Access token lifespan should be configured to be greater than the SSE connection timeout. ' +
                            'Usually a 10mn access token lifespan is recommended. The retrieved token lifespan is ').concat(expirationDuration, "s, which leaves only ").concat(delayBetweenRefresh, "s of delay between 2 refresh."));
                    }
                }
                return Promise.resolve(refreshed);
            })
                .catch(function (err) {
                console.log("An error occurred can't perform token refresh:", err);
                // Not conventional but asked to let the disconnection sound notification play
                setTimeout(function () { return _this.logout(); }, 500);
                return Promise.reject();
            });
        }
        else {
            throw new Error('Please init Keycloak first');
        }
    };
    KeycloakEntity.login = function () {
        if (this.kc) {
            this.kc.login();
        }
        else {
            throw new Error('Please init Keycloak first');
        }
    };
    KeycloakEntity.logout = function () {
        var _this = this;
        StreamEntity.stopAllSSE().then(function () {
            saveInLocalStorage({ streamRunning: [] });
            broadcastToAllTabs(E_BROADCAST_MESSAGE.DISCONNECT, { id: _this.kc.sessionId });
        });
        if (this.kc) {
            if (!this.kc.idToken && this.idToken !== null) {
                this.kc.idToken = this.idToken;
            }
            this.kc
                .logout()
                .then(function (res) { return console.log('logout succeeded'); })
                .catch(function (e) { return console.log('logout error', e); })
                .finally(function () { return console.log('logout finish'); });
            this.kc.clearToken();
            return null;
        }
        else {
            throw new Error('Please init Keycloak first');
        }
    };
    KeycloakEntity.kc = null;
    KeycloakEntity.kcConfig = null;
    KeycloakEntity.userInfo = null;
    // We need to store the idToken because it is cleared on error
    KeycloakEntity.idToken = null;
    return KeycloakEntity;
}());
export { KeycloakEntity };
